// 新加坡主体1下的各app
const SINGAPORE_BODY_1_PRODUCTS = new Set(['couplelens', 'vimi', 'veeo', 'beyo', 'heyo', 'beatmo']);

export function isGoogleLoginHiddenByMainBody(product: string) {
	return SINGAPORE_BODY_1_PRODUCTS.has(product);
}
